<template>
  <div>
    <el-form size="mini" label-width="140px" label-position="left">
      <el-row>
        <el-col :span="13">
          <el-form-item :label="$l('form_label_riskCheckNo') || '核查单号'">
            <div>{{ formData.riskCheckNo }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$l('form_label_riskCheckStatus') || '核查状态'">
            <div>
              <el-tag
                :type="formData.riskCheckStatus === 'N' ? 'info' : ''"
                size="mini"
              >
                {{ formData.v_riskCheckStatus }}
              </el-tag>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="13">
          <el-form-item :label="$l('form_label_custName') || '客户名称'">
            <div>{{ formData.custName }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$l('form_label_customerBizType') || '客户类型'">
            <div>{{ formData.v_customerBizType }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="13">
          <el-form-item :label="$l('form_label_businessLicense') || '客户税号'">
            <div>{{ formData.businessLicense }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$l('form_label_region') || '所在国家'">
            <div>{{ formData.regionName }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="13">
          <el-form-item :label="$l('form_label_createBy') || '提交人'">
            <div>{{ formData.createByName }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$l('form_label_createDate') || '提交时间'">
            <div>{{ formData.createDate }}</div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div style="margin: 20px 0;">
      <h6 style="color: #101010;">
        {{ $l('form_header_base') || '核查信息' }}
      </h6>
      <p style="font-size:14px;color: #6C6C6C;" class="m-0 text-truncate">
        {{
          $l('form_paragraph_base') ||
            '外贸客户需核查中信保，内贸客户需通过天眼查，核查客户整体情况'
        }}
      </p>
    </div>
    <el-form
      ref="form"
      size="mini"
      label-width="140px"
      label-position="left"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      :show-message="false"
    >
      <el-row>
        <el-col :span="13">
          <el-form-item
            :label="$l('form_label_riskCheckChannel') || '核查渠道'"
            prop="riskCheckChannel"
          >
            <dict-select
              v-model="formData.riskCheckChannel"
              url="/master/common/dict/biz"
              :body="{ dictType: 'riskCheckChannel' }"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item
            :label="$l('form_label_riskCheckDate') || '核查日期'"
            prop="riskCheckDate"
          >
            <el-date-picker
              v-model="formData.riskCheckDate"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="13">
          <el-form-item
            :label="$l('form_label_riskLevel') || '风险等级评估'"
            prop="riskLevel"
          >
            <el-radio-group v-model="formData.riskLevel">
              <el-radio-button label="normal">
                {{ $l('form_label_riskLevel_normal') || '正常' }}
              </el-radio-button>
              <el-radio-button label="lowRisk">
                {{ $l('form_label_riskLevel_lowRisk') || '低风险' }}
              </el-radio-button>
              <el-radio-button label="highRisk">
                {{ $l('form_label_riskLevel_highRisk') || '高风险' }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item
            :label="$l('form_label_riskCheckBy') || '核查人'"
            prop="riskCheckByCode"
          >
            <dict-select
              v-model="formData.riskCheckByCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.riskCheckByName"
              filterable
              clearable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_riskCheckDesc') || '评估结果说明'"
            prop="riskCheckDesc"
          >
            <div style="margin: 3px 0;">
              <Editor v-model="formData.riskCheckDesc" :disabled="disabled" />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="el-form-item el-form-item--mini">
            <div class="el-form-item__label" style="width: 140px;">
              <div>{{ $l('form_label_riskCheckDoc') || '检查结果文件' }}</div>
              <div class="mt-2" v-if="!disabled">
                <el-button
                  type="primary"
                  size="mini"
                  style="width: 100%;"
                  @click.stop="uploadDocVisible = true"
                >
                  {{ $l('btn_uploadDoc') || '上传文件' }}
                </el-button>
              </div>
            </div>
            <div class="el-form-item__content">
              <div
                class="risk-check-doc__wrapper"
                v-if="listDoc && listDoc.length"
              >
                <div
                  class="risk-check-doc__item"
                  v-for="(doc, index) in listDoc"
                  :key="index"
                >
                  <div class="d-flex flex-row mb-2">
                    <div class="d-flex">
                      <el-avatar
                        shape="square"
                        class="bg-transparent"
                        :src="doc.fileTypeIcon"
                      />
                    </div>
                    <div class="flex-grow-1 d-flex flex-column">
                      <p class="m-0 risk-check-doc__name">{{ doc.fileName }}</p>
                      <p class="m-0 flex-grow-1 risk-check-doc__desc">
                        {{ doc.fileDesc }}
                      </p>
                    </div>
                  </div>
                  <div class="d-flex flex-row align-items-end">
                    <div class="flex-grow-1 risk-check-doc__desc">
                      <span>{{ doc.uploadName }}</span>
                      <br />
                      <span>{{ doc.uploadTime || 'current time' }}</span>
                    </div>
                    <div>
                      <span v-if="!disabled">
                        <i
                          class="el-icon-delete tool-btn"
                          style="color: #FA5C7C;"
                          @click="delDoc(index)"
                        />
                      </span>
                      <span>
                        <i
                          class="el-icon-view tool-btn"
                          @click="viewDoc(doc)"
                        />
                      </span>
                      <span>
                        <i
                          class="el-icon-download tool-btn"
                          @click="downloadDoc(doc)"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="form_empty_doc">
                  <img src="/image/static/img/nodata.png" />
                  <p class="mb-0 mt-2">
                    {{
                      disabled
                        ? $l('form_empty_doc') || '无检查结果文件'
                        : $l('form_tips_doc') ||
                          '请点击左边上传按钮，上传文件！'
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <UploadDoc :visible.sync="uploadDocVisible" @confirm="uploadConfirm" />

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { request } from '@/api/service'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import Editor from '@/views/digital/components/editor'
import UploadDoc from '../upload-doc'
export default {
  components: { Editor, UploadDoc },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    riskCheckCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      rules: {
        riskCheckChannel: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        riskCheckDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        riskLevel: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        riskCheckByCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        riskCheckDesc: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
      fileIcons: {},
      uploadDocVisible: false,
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
    listDoc() {
      const data = this.formData?.listDoc || []
      return data.map((item) => {
        const fileTypeIcon = this.getFileIcon(item.fileName)
        return { ...item, fileTypeIcon }
      })
    },
  },
  mounted() {
    this.getData()
    this.getFileIcons()
  },
  methods: {
    async getData() {
      if (!this.riskCheckCode) return
      const res = await this.$api
        .customerRiskCheckDetailApi({ riskCheckCode: this.riskCheckCode })
        .catch(() => null)
      this.formData = res?.body || {}
      setTimeout(() => this.$refs.form.clearValidate(), 0)
    },
    async getFileIcons() {
      const res = await request({
        url: '/sys/common/dict/system',
        method: 'POST',
        data: { dictType: 'FileTypeIcon' },
      }).catch(() => null)

      const data = res?.body?.data || []
      this.fileIcons = Object.fromEntries(
        data.map(({ value, label }) => [value, label])
      )
    },
    getFileIcon(fileName) {
      const getFileType = (filename) => {
        if (!filename) return ''
        if (!filename.includes('.')) return ''
        return filename.split('.').pop()
      }

      const fileType = getFileType(fileName) || 'OTHER'
      return this.$osscdn(
        this.fileIcons[fileType.toUpperCase()] || this.fileIcons['OTHER']
      )
    },
    uploadConfirm(data) {
      if (!data?.length) return

      const { userName, userNameEn } = this.userInfo
      const uploadName = [userNameEn, userName].filter(Boolean).join('-')

      const listDoc = this.formData.listDoc || []
      listDoc.unshift(
        ...data.map((item) => {
          const fileTypeIcon = this.getFileIcon(item.fileName)
          return { ...item, fileTypeIcon, uploadName }
        })
      )
      this.formData.listDoc = listDoc
    },
    delDoc(index) {
      const listDoc = this.formData.listDoc || []
      listDoc.splice(index, 1)
      this.formData.listDoc = listDoc
    },
    viewDoc({ fileCode }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode, { isAutoDown: true, preview: true })
    },
    downloadDoc({ fileCode }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      if (this.loadingOpen()) return
      const res = await this.$api
        .customerRiskCheckSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.$emit('reload')
      this.close()
    },
    cancel() {
      if (this.disabled) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-form {
    border: 1px solid #ebeef5;
    border-bottom: none;
    border-right: none;
    .el-form-item {
      margin-bottom: 0 !important;
      display: flex;
      border-bottom: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;

      .el-form-item__label,
      .el-form-item__content {
        font-size: 12px;
        font-weight: 400;
        line-height: 1.5;
        color: #101010;
      }
      .el-form-item__label {
        background: #fafafa;
        padding: 8px 10px;
        border-right: 1px solid #ebeef5;
      }
      .el-form-item__content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        margin-left: 0 !important;
        > * {
          flex: 1;
        }
      }
    }
    .el-form-item.is-error {
      .el-radio-button__inner,
      .ql-toolbar.ql-snow,
      .ql-container.ql-snow {
        border-color: #f56c6c;
      }
    }
  }

  .el-radio-group {
    display: flex;
    .el-radio-button {
      flex: 1;
      .el-radio-button__inner {
        width: 100%;
      }
    }
  }
}

.form_empty_doc {
  text-align: center;
  color: #606266;
  font-size: 13px;
  padding: 20px 0;
}

.risk-check-doc__wrapper {
  display: flex;
  flex-wrap: wrap;
  --gutter: 10px;
  padding-bottom: var(--gutter);
  .risk-check-doc__item {
    width: calc(50% - calc(var(--gutter) / 2));
    margin-top: var(--gutter);
    margin-right: var(--gutter);
    padding: 6px;
    border: 1px solid #bbbbbb;
    border-radius: 5px;
    .el-avatar {
      width: 60px;
      height: 60px;
      margin-right: 6px;
      img {
        width: 100%;
      }
    }
    .risk-check-doc__name {
      font-size: 14px;
      color: rgba(16, 16, 16, 1);
      line-height: 20px;
      margin-bottom: 2px !important;
      word-break: break-all;
    }
    .risk-check-doc__desc {
      font-size: 12px;
      color: rgba(142, 142, 142, 1);
      line-height: 17px;
      word-break: break-all;
    }
  }
  .risk-check-doc__item:nth-child(even) {
    margin-right: 0;
  }
}
</style>
